import React from 'react';
import { NavLink } from '@shared/core';

interface INavigationWrapperProps {
  link?: string;
  route?: string;
  children: React.ReactNode;
}

export const NavigationWrapper: React.FC<INavigationWrapperProps> = ({ link, route, children }) => {
  // If a route is provided we attempt SPA routing to avoid page refresh
  if (route) {
    return (
      <NavLink
        style={{ textDecoration: 'none' }}
        to={route ?? ''}
      >
        {children}
      </NavLink>
    );
  }
  // If no route is provided, we fallback to see if a link was provided which we assume cannot happen with SPA routing
  if (link) {
    return (
      <a
        href={link}
        style={{ textDecoration: 'none' }}
      >
        {children}
      </a>
    );
  }
  // Fallback to a div if neither route nor link is provided
  return <div style={{ width: '100%', height: '100%' }}> {children}</div>;
};
